/** Default sizes for PDF widget fields (PDF user units, same as PdfPreview). */
export const DEFAULT_FIELD_SIZES = {
  checkbox: { width: 34, height: 34 },
  text: { width: 124, height: 24 },
  signature: { width: 124, height: 44 },
  date: { width: 124, height: 24 },
};

/**
 * Creates a field object for the template / acknowledge PDF canvas (bottom-left PDF origin for y).
 */
export function buildPlacementField(type, ctx) {
  const {
    currentSignerIndex,
    currentPage,
    originalWidth,
    originalHeight,
    displayWidth,
    displayHeight,
    scrollTop,
    viewportHeight,
    offsetX,
    offsetY,
  } = ctx;

  const fieldSize = DEFAULT_FIELD_SIZES[type] || DEFAULT_FIELD_SIZES.text;
  const scale = displayWidth / originalWidth;
  const fieldHeightDisplay = fieldSize.height * scale;
  const pageMargin = 20;

  let x;
  let y;

  if (offsetX != null && offsetY != null && displayHeight != null) {
    const displayX = offsetX;
    const browserY = offsetY;
    x = displayX / scale;
    // browserY and displayHeight are display px; field height must be scaled before subtracting.
    const pdfY = (displayHeight - browserY - fieldHeightDisplay) / scale;
    y = pdfY;
  } else {
    const browserY = scrollTop + viewportHeight / 2 - fieldHeightDisplay / 2 - pageMargin;
    const pdfY = originalHeight - browserY / scale - fieldSize.height;
    x = 100;
    y = pdfY;
  }

  return {
    id: `field-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    type,
    x,
    y,
    width: fieldSize.width,
    height: fieldSize.height,
    signerIndex: currentSignerIndex,
    page: currentPage,
  };
}

/** Default ghost for routing items — PDF user units (same basis as `DEFAULT_FIELD_SIZES`). */
export const ROUTING_ITEM_GHOST = { width: 120, height: 28 };
